// api.js
const API_URL = 'http://8.152.210.15';

const fetchWithAuth = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token');
    const headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        throw new Error('API request failed');
    }

    return response.json();
};

export const login = async (email, password) => {
    return await fetchWithAuth(`/auth/login?mail=${email}&password=${password}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mail: email, password }),
    });
};

// 其他 API 请求可以使用类似的方法
export const getSomeData = async () => {
    return await fetchWithAuth('/some/protected/endpoint');
};

export const boxList = async ({ userId }) => {
    return await fetchWithAuth(`/mail/getList?userId=${userId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const wordList = async () => {
    return await fetchWithAuth(`/word/list`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const wordDetail = async (id) => {
    return await fetchWithAuth(`/word/detail?id=${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const trans = async ({ word }) => {
    return await fetchWithAuth(`/word/trans?word=${word}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const mailDetail = async ({ id }) => {
    return await fetchWithAuth(`/mail/detail?id=${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

export const mailSend = async (req) => {
    return await fetchWithAuth('/mail/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(req),
    }).catch(() => {
        console.error('上传失败');
    });
}

export const getContentByUserId = async ({ userId }) => {
    return await fetchWithAuth(`/content/getByUserId?userId=${userId}`, {
        method: 'GET', // 通常使用 GET 方法
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const contentSave = async (content) => {
    return await fetchWithAuth('/content/save', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(content),
    });
};

export const wordSave = async (content) => {
    return await fetchWithAuth('/word/save', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(content),
    });
};

export const userDetail = async () => {
    return await fetchWithAuth('/user/detail', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

export const anotherUserDetail = async () => {
    return await fetchWithAuth('/user/another', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

export const read = async ({ id }) => {
    return await fetchWithAuth(`/mail/read?id=${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

export const unReadCount = async () => {
    return await fetchWithAuth('/mail/unReadMailCount', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};